<template>
  <div class="recommend-start">
    <span class="start-grey" :style="{width: ((5 - startNum) / 5)*100 + '%'}"></span>
    <b>{{twoFixed}}</b>
  </div>
</template>
<script>
  export default {
    name: '',
    data () {
      return {}
    },
    props: ['startNum'],
    computed: {
      twoFixed (){
        return this.startNum.toFixed(1)
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../static/css/common.scss';
  .recommend-start{
    width: 110px;
    height: 20px;
    margin-top: 5px;
    background: {
      repeat: no-repeat;
      size: 110px 20px;
      image: url("../../static/images/start-blue.png");
    };
    position: relative;
    margin-bottom: 10px;
    .start-grey{
      position: absolute;
      width: 110px;
      height: 20px;
      top: 0;
      right: 0;
      background: {
        repeat: no-repeat;
        size: 110px 20px;
        image: url("../../static/images/start-grey.png");
        position: right center;
      };
    }
    b{
      position: absolute;
      right: -33px;
      color: $color-start;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RecommendStart.vue